export var Shape;

(function (Shape) {
  Shape["GROUP"] = "g";
  Shape["CIRCLE"] = "circle";
  Shape["ELLIPSE"] = "ellipse";
  Shape["IMAGE"] = "image";
  Shape["RECT"] = "rect";
  Shape["LINE"] = "line";
  Shape["POLYLINE"] = "polyline";
  Shape["POLYGON"] = "polygon";
  Shape["TEXT"] = "text";
  Shape["PATH"] = "path";
  Shape["HTML"] = "html";
})(Shape || (Shape = {}));

export var LineCap;

(function (LineCap) {
  LineCap["BUTT"] = "butt";
  LineCap["ROUND"] = "round";
  LineCap["SQUARE"] = "square";
})(LineCap || (LineCap = {}));

export var LineJoin;

(function (LineJoin) {
  LineJoin["BEVEL"] = "bevel";
  LineJoin["ROUND"] = "round";
  LineJoin["MITER"] = "miter";
})(LineJoin || (LineJoin = {}));

export var TextTransform;

(function (TextTransform) {
  TextTransform["CAPITALIZE"] = "capitalize";
  TextTransform["UPPERCASE"] = "uppercase";
  TextTransform["LOWERCASE"] = "lowercase";
  TextTransform["NONE"] = "none";
})(TextTransform || (TextTransform = {}));

export var TextAlign;

(function (TextAlign) {
  TextAlign["START"] = "start";
  TextAlign["CENTER"] = "center";
  TextAlign["END"] = "end";
  TextAlign["LEFT"] = "left";
  TextAlign["RIGHT"] = "right";
})(TextAlign || (TextAlign = {}));

export var CanvasConfig = 'CanvasConfig';